import AdminEvents from "./AdminEvents";

export default AdminEvents;
